import type { SearchUsersParams } from './user.api';

export const userKeys = {
  all: ['users'] as const,
  search: (params: SearchUsersParams): readonly unknown[] => [...userKeys.all, 'search', params] as const,
};
